// extracted by mini-css-extract-plugin
export default {"section":"container-scroll_section__33L4M"};